import { Badge, BadgeProps } from 'antd';

export const AntBadge = Badge;
export type AntBadgeProps = BadgeProps;
